/**
 * Several Vephus accounts on one computer (docs/refactor/45): each in a process of its own (`vephus --profile <name>`),
 * with its own sign-in, keys and folders. Desktop only; a browser has none.
 */

import { isDesktop } from './desktop'

declare global {
  interface Window {
    /** Set by the desktop app before the page loads, in another account's windows (lib.rs). */
    __VEPHUS_PROFILE__?: string
  }
}

/** This window's account profile, or null for the default account (and in a browser). */
export function currentProfile(): string | null {
  if (typeof window === 'undefined' || !isDesktop()) return null
  const name = window.__VEPHUS_PROFILE__
  return typeof name === 'string' && /^[a-z0-9-]{1,32}$/.test(name) ? name : null
}

async function invoke<T>(command: string, args?: Record<string, unknown>): Promise<T> {
  const { invoke: call } = await import('@tauri-apps/api/core')
  return call<T>(command, args)
}

/** The accounts opened before on this computer. */
export function profilesList(): Promise<string[]> {
  return isDesktop() ? invoke<string[]>('profiles_list') : Promise.resolve([])
}

/** Opens an account in a window of its own: the one named, or a new one. Resolves to its name. */
export function profileOpen(name?: string): Promise<string> {
  return invoke<string>('profile_open', { name: name ?? null })
}
